import amplitude from 'amplitude-js';
import {isInternalUser} from 'src/utils/check-internal-user';
import logger from 'src/utils/logger';
import {captureSentryException} from 'src/utils/sentry';


const ENABLED = true;

const AMPLITUDE_TOKEN_KEY = {
  PRODUCTION: 'fd60f8fe13c1b2a8bdcb465df096f25d',
  DEVELOPMENT: 'b3a35e90cd3dbb04e0329b3cbb09fe84',
} as const;

// Local function
// [TODO]: handle from api, can be enabled through API
const isEnabled = () => ENABLED;

const loadService = (ENV: string) => {
  try {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly PRODUCTION: "fd60f8fe13c1b2a8bdcb465df096f25d"; readonly DEVELOPMENT: "b3a35e90cd3dbb04e0329b3cbb09fe84"; }'.
    const KEY = AMPLITUDE_TOKEN_KEY[ENV];
    if (amplitude && isEnabled()) {
      // @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type 'string | undefined'.
      amplitude.getInstance().init(KEY, null, {includeReferrer: true});
    }
  } catch (e: any) {
    captureSentryException(e, {
      level: 'error',
      tags: {
        operation: 'amplitude init failed',
      },
    });
  }
};

const identify = (userId: string, userDetails: unknown) => {
  try {
    if (amplitude && isEnabled() && !isUserIdExist()) {
      amplitude.getInstance().setUserId(userId);
      if (userDetails) {
        register(userDetails);
      }
    }
  } catch (e: any) {
    logger.info('error while identifying and registering user in amplitude', e);
  }
};

const register = (userDetails: unknown) => {
  if (amplitude && isEnabled()) {
    amplitude
      .getInstance()
      // @ts-expect-error - TS2698 - Spread types may only be created from object types.
      .setUserProperties({...userDetails, internalUser: isInternalUser()});
  }
};

const trackPage = (props: unknown) => {
  try {
    if (amplitude && isEnabled()) {
      amplitude.getInstance().logEvent('page-viewed', props);
    }
  } catch (e: any) {
    logger.info('error while tracking amplitude page-viewed', e);
  }
};

const track = (eventName: string, props: unknown) => {
  try {
    if (amplitude && isEnabled()) {
      amplitude.getInstance().logEvent(eventName, props);
    }
  } catch (e: any) {
    logger.info('error while tracking amplitude event', e);
  }
};
// Public functions
const init = (ENV: string) => {
  if (isEnabled()) {
    loadService(ENV);
  }
};

const reset = () => {
  if (isEnabled()) {
    try {
      amplitude.getInstance().resetSessionId();
    } catch (error: any) {
      console.log('error while resting the amplitude', error);
    }
  }
};

export const AnalyticsService = {
  init,
  identify,
  trackPage,
  register,
  track,
  reset,
} as const;

// util function

const isUserIdExist = () => amplitude.getInstance().getUserId();
